// LIB
import { Dispatch } from 'redux';
import { Capacitor } from '@capacitor/core';

import { NavigationData, NavigationPlugin } from '../../../capacitor_plugins/navigation';
import { navigateToBoard } from '../../reducers/navigationActions';
import { CAPACITOR_NAVIGATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { navigateToQuicknotes } from '../../capacitor/actions/quickNotesActions';
import platformSingleton from '../../platform/platformSingleton';
import { DeviceFormFactor } from '../../../common/platform/platformTypes';
import { openPopup } from '../../components/popupPanel/popupActions';
import { PopupIds } from '../../components/popupPanel/popupConstants';
import quickNotesPopupStayActivePredicate from '../../workspace/header/workspaceToolsHeader/quickNotes/popup/quickNotesPopupStayActivePredicate';

export const addListenerForNavigation = () => {
    return function (dispatch: Dispatch<any>) {
        if (Capacitor.isPluginAvailable(CAPACITOR_NAVIGATION_PLUGIN)) {
            NavigationPlugin.addListener('navigate', (data: NavigationData) => {
                const boardId = data.boardId;
                const navigationSource = data.source;

                dispatch(navigateToBoard({ boardId, navigationSource }));
            });
        }
    };
};

export const addListenerForQuicknotesNavigation = () => {
    return function (dispatch: Dispatch<any>) {
        if (!Capacitor.isPluginAvailable(CAPACITOR_NAVIGATION_PLUGIN)) return;

        NavigationPlugin.addListener('navigateToQuicknotes', () => {
            if (platformSingleton.formFactor !== DeviceFormFactor.phone) {
                dispatch(openPopup({ popupId: PopupIds.QUICK_NOTES, predicateFn: quickNotesPopupStayActivePredicate }));
                NavigationPlugin.onQuicknotesNavigation();
                return;
            }

            dispatch(navigateToQuicknotes());
        });
    };
};
